import React, { useState, useEffect } from 'react';
import * as MenuConfig from "../../Menu/MenuConfig"

export function ContentHeader({ headerName, headerDescription, breadcrumbs }) {

  const [mPageName, setPageName] = useState("")
  const [mPageDescription, setPageDescription] = useState("")
  const [mBreadcrumbs, setBreadcrumbs] = useState([])
  /*
  console.log(typeof(menuList))
  menuList.forEach(element => {
    console.log(element)
  });
  */

  useEffect(()=>{
    if (breadcrumbs !== undefined && breadcrumbs !== mBreadcrumbs) {
      setBreadcrumbs(breadcrumbs);
    }
    if(headerName !== undefined && headerName !== mPageName){
      setPageName(headerName)
    }
    if(headerDescription !== undefined && headerDescription !== mPageDescription){
      setPageDescription(headerDescription)
    }
  })


  return (
    <div className="row wrapper border-bottom white-bg page-heading">
      <div className="col-lg-10">
        <h2>{mPageName}</h2>
        <small>{mPageDescription}</small>
        <ol className="breadcrumb">
          <li>
            <a href="/">首頁</a>
          </li>
          {
            mBreadcrumbs.map((items)=>(
              <li key={items}>
                {items}
              </li>
            ))
          }
        </ol>
      </div>
      <div className="col-lg-2">

      </div>
    </div>
  )
}